module.exports = __webpack_public_path__ + "assets/img/label-classify-4.45a1a2da.png";